import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { User } from 'oidc-client';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IPolCoreState } from '../../models/state.model';
import { POLAuthService } from '../../services/auth.service';
import { actionRefreshToken, actionSignInUser } from '../../state/core.actions';
import { getRefreshTokenUrl } from '../../state/core.selectors';

@Component({
  selector: 'app-refresh-token-wrapper',
  templateUrl: './refresh-token-wrapper.component.html',
  styleUrls: ['./refresh-token-wrapper.component.scss']
})
export class RefreshTokenWrapperComponent implements OnInit {
  src: SafeResourceUrl = null;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  refreshTokenUrl$: Observable<any> = this.store.select(getRefreshTokenUrl).pipe(takeUntil(this.ngUnsubscribe));

  constructor(
    private authService: POLAuthService,
    private sanitizer: DomSanitizer,
    private store: Store<IPolCoreState>,
    public oidc: OidcClientService
  ) {}

  ngOnInit(): void {
    this.refreshTokenUrl$.subscribe((refreshToken: { isRefreshInProgress: boolean; url: string }) => {
      console.log('url', refreshToken.url);
      if (refreshToken.url) {
        console.log('(refreshToken.url', (refreshToken.url));
        this.src = this.sanitizer.bypassSecurityTrustResourceUrl(refreshToken.url);
      } else {
        this.src = null;
      }
    });
  }

  onMyFrameLoad() {
    console.log(`onMyFrameLoad Event`);
    this.oidc.getUserComputed().subscribe(
      (newUser: User) => {
        if (newUser) {
          const oldUser = this.oidc.getUser();
          console.log(`new user`, newUser);
          console.log(`old user`, oldUser);
          if (newUser.id_token !== oldUser.id_token) {
            this.oidc.userManager.events.load(newUser);
            this.store.dispatch(actionSignInUser({ user: newUser }));
            console.log('firing the dispatch to set to null');
            this.store.dispatch(actionRefreshToken({ refreshToken: { isRefreshInProgress: false, url: null } }));
          }
        }
      },
      (error) => {
        console.log(`Error in getUserComputed: ${error}`);
      }
    );
  }

  refreshToken() {
    this.store.dispatch(
      actionRefreshToken({ refreshToken: { isRefreshInProgress: true, url: this.authService.refreshTokenUrl() } })
    );
  }
}
